/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const GenerateChartGraphInputJsonApiModel = {
  id: "",
  chart: {
    jsonApi: "hasOne",
    type: "charts",
  },
  "chart-id": "",
  nodes: {
    jsonApi: "hasMany",
    type: "charts",
  },
  "graph-output-format": "",
  base64: "",
};
